import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        background: {
            default: '#F5F6F8',
        },
        error: {
            main: '#d11a2a',
        },
        primary: {
            dark: '#05673F',
            light: '#078252',
            main: '#078252',
        },
        secondary: {
            dark: '#05673F',
            light: '#f3d718',
            main: '#05673F',
        },
    },
});

export default theme;
